import { useEffect, useRef } from 'react'

import { RecentOpenKind } from '@digital-twins/shared-types'

import { bumpRailItem } from '@/components/layout/useSidebarThreads'
import { recentConversationsApi } from '@/lib/api'
import { useAuth } from '@/lib/config/auth-provider'

/**
 * Records that the signed-in user opened a thread, room, experiment or draft so
 * the Recent rail orders it by last open. Keyed on `(kind, token)`, not mount:
 * a draft id that appears after creation fires once it exists, and a re-render
 * with the same pair does nothing. Fire-and-forget; a failed POST (including a
 * 404 for an item the user cannot see) is ignored. Skipped for guests and while
 * `token` is empty.
 */
export function useRecordRecentOpen(kind: RecentOpenKind, token: string | null | undefined): void {
  const { isAuthenticated } = useAuth()
  const lastRecordedRef = useRef<string | null>(null)

  useEffect(() => {
    if (!isAuthenticated || !token) {
      return
    }
    const key = `${kind}:${token}`
    if (lastRecordedRef.current === key) {
      return
    }
    lastRecordedRef.current = key
    recentConversationsApi
      .recordOpen({ kind, token })
      .then(() => {
        bumpRailItem(kind, token, new Date().toISOString())
      })
      .catch(() => undefined)
  }, [isAuthenticated, kind, token])
}
